import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { productKeys } from './keys';

import type { TypeGetSkusParams, TypeGetSkusResponse } from '~/types/product.types';

/**
 * [상품관리] 상품 리스트 조회 API
 */
export const fetchSkus = async (params: TypeGetSkusParams): Promise<TypeGetSkusResponse> => {
  const { data } = await axiosInstance.get<TypeGetSkusResponse>(API_ENDPOINT.PRODUCT.GET_SKUS, { params });
  return data;
};

type UseGetSkusQueryOptions = {
  params: TypeGetSkusParams;
  enabled?: boolean;
  showGlobalDimOverlay?: boolean;
};

/**
 * [상품관리] 상품 리스트 조회 Query Hook
 *
 * @description 상품등록/수정, 운영상품조회, 교환상품추가에서 사용
 * - [운영상품조회] 상품 리스트 조회 (status = 'ACTIVE', isActive = true 필수)
 * - [교환 신청/조회] 교환 상품 추가 > 상품 리스트 조회 (status = 'ACTIVE', isActive = true 필수)
 */
export const useGetSkusQuery = ({ params, enabled = true, showGlobalDimOverlay = true }: UseGetSkusQueryOptions) => {
  return useQuery({
    queryKey: productKeys.skus(params),
    queryFn: () => fetchSkus(params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
    meta: { showGlobalDimOverlay },
  });
};
